import { useSdk } from '~/sdk';
import { useQuery, useMutation, useQueryClient } from '@tanstack/vue-query';
import type { Reactive } from 'vue';

export function useDeliveryNote() {
    const queryClient = useQueryClient();
    
    // Query to fetch the delivery note
    const query = useQuery({
        queryKey: ['deliveryNote'],
        queryFn: async () => {
            const result = await useSdk().commerce.getDeliveryMessage();
            return result?.message || '';
        }
    });
    
    // Mutation to update the delivery note
    const mutation = useMutation({
        mutationFn: async (note: string) => {
            return await useSdk().commerce.addOrEditDeliveryMessage({ message: note });
        },
        onSuccess: () => {
            // Invalidate and refetch the delivery note query when a mutation is successful
            queryClient.invalidateQueries({ queryKey: ['deliveryNote'] });
        }
    });

    return {
        query: reactive(query) satisfies Reactive<typeof query>,
        mutation: reactive(mutation) satisfies Reactive<typeof mutation>,
        data: computed(() => query.data.value || ''),
        addOrUpdateNote: (note: string) => mutation.mutate(note),
        execute: () => query.refetch()
    };
}
